"use strict";
// TODO: Get rid of this file.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountId = exports.getUserId = void 0;
const uuid = __importStar(require("uuid"));
const UUID_NAMESPACE = '0f9da948-a6fb-4c45-9edc-4685c3f3317d';
function getUserId(address) {
    return uuid.v5(Buffer.from(address.toLowerCase()), UUID_NAMESPACE);
}
exports.getUserId = getUserId;
function getAccountId({ address, accountNumber = '0', }) {
    return uuid.v5(Buffer.from(`${getUserId(address)}${accountNumber}`), UUID_NAMESPACE);
}
exports.getAccountId = getAccountId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2RiLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw4QkFBOEI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRTlCLDJDQUE2QjtBQUU3QixNQUFNLGNBQWMsR0FBVyxzQ0FBc0MsQ0FBQztBQUV0RSxTQUFnQixTQUFTLENBQ3ZCLE9BQWU7SUFFZixPQUFPLElBQUksQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsV0FBVyxFQUFFLENBQUMsRUFBRSxjQUFjLENBQUMsQ0FBQztBQUNyRSxDQUFDO0FBSkQsOEJBSUM7QUFFRCxTQUFnQixZQUFZLENBQUMsRUFDM0IsT0FBTyxFQUNQLGFBQWEsR0FBRyxHQUFHLEdBSXBCO0lBQ0MsT0FBTyxJQUFJLENBQUMsRUFBRSxDQUNaLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxTQUFTLENBQUMsT0FBTyxDQUFDLEdBQUcsYUFBYSxFQUFFLENBQUMsRUFDcEQsY0FBYyxDQUNmLENBQUM7QUFDSixDQUFDO0FBWEQsb0NBV0MifQ==